import { is, canIUse, subscribe } from '@didi/webx-js'
import { URLQueries } from '../webx'

export const mpSubscribe = () => {
  const fromMiniPay = URLQueries.getQuery('from_mini_pay')
  if (fromMiniPay && is('miniprogram') && canIUse('subscribe')) {
    subscribe({
      activity_id: 'taocan_xcxtz',
    })
  }
}
